import { render, staticRenderFns } from "./vribbon.vue?vue&type=template&id=9d325e2c&scoped=true"
import script from "./vribbon.vue?vue&type=script&lang=ts"
export * from "./vribbon.vue?vue&type=script&lang=ts"
import style0 from "./vribbon.vue?vue&type=style&index=0&id=9d325e2c&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d325e2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d325e2c')) {
      api.createRecord('9d325e2c', component.options)
    } else {
      api.reload('9d325e2c', component.options)
    }
    module.hot.accept("./vribbon.vue?vue&type=template&id=9d325e2c&scoped=true", function () {
      api.rerender('9d325e2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vertical-ribbon/vribbon.vue"
export default component.exports